<template>
  <b-row no-gutters
         data-test="s-modal-header-row"
         class="flex-nowrap w-100"
         :class="wrapperClasses"
  >
    <b-col v-if="!hideLeftActionSlot"
           class="text-left"
           :cols="colSize.left"
    >
      <slot name="left-action">
        <b-button
          v-if="showDefaultLeftAction"
          variant="transparent"
          class="reset-button"
          data-test="back-button"
          @click="$emit('back-nav-action')"
        >
          <sdui-icon class="icon-arrow-left font-24 d-block primary" />
          <span class="sr-only">{{ $t('global.back') }}</span>
        </b-button>
      </slot>
    </b-col>
    <b-col class="pl-1 pr-1" :cols="colSize.center">
      <slot name="center-action" />
    </b-col>
    <b-col class="text-right h-100" :cols="colSize.right">
      <slot name="right-action">
        <b-button
          v-if="showDefaultRightAction"
          variant="transparent"
          data-test="close-modal-btn"
          class="reset-button close-modal-btn"
          @click="$emit('close-modal')"
        >
          <sdui-icon class="icon-close-o-16 circle" data-cy="modal-close" />
          <span class="sr-only">{{ $t('global.modal_header.close') }}</span>
        </b-button>
      </slot>
    </b-col>
  </b-row>
</template>

<script>
import isMobileDeviceMixin from 'src/mixins/miscellaneous/isMobileDeviceMixin.js'

export default {
  name: 'SModalHeader',
  mixins: [isMobileDeviceMixin],
  props: {
    showDefaultLeftAction: {
      type: Boolean,
      default: true,
    },

    showDefaultRightAction: {
      type: Boolean,
      default: true,
    },

    hideLeftActionSlot: {
      type: Boolean,
      default: false,
    },

    wrapperClasses: {
      type: String,
      default: 'align-items-center',
    },
  },

  data: () => ({
    slots: {
      left: false,
      right: false,
    },
  }),

  computed: {
    slotsOverridden() {
      return this.slots.left || this.slots.right
    },

    colSize() {
      // if no slots are overridden we assume that the default actions should be shown
      if (!this.slotsOverridden) {
        if (!this.hideLeftActionSlot) return { left: 1, center: 10, right: 1 }
        return { left: 0, center: 9, right: 3 }
      }

      if (!this.hideLeftActionSlot) {
        return {
          left: 3,
          center: 6,
          right: 3,
        }
      }

      return {
        left: 0,
        center: 9,
        right: 3,
      }
    },
  },

  emits: ['back-nav-action', 'close-modal'],

  methods: {
    updateLocalSlots(leftActionSlotExists, rightActionSlotExists) {
      this.slots = {
        left: leftActionSlotExists,
        right: rightActionSlotExists,
      }
    },

    hasLeftActionSlot() {
      return this.$hasSlotContent(this.$slots['left-action'])
    },

    hasRightActionSlot() {
      return this.$hasSlotContent(this.$slots['right-action'])
    },
  },

  mounted() {
    this.updateLocalSlots(!!this.hasLeftActionSlot(), !!this.hasRightActionSlot())
  },

  beforeUpdate() {
    // slots are not reactive but when a slot is changed/added dynamically, beforeUpdate is gonna be fired
    this.updateLocalSlots(!!this.hasLeftActionSlot(), !!this.hasRightActionSlot())
  },
}
</script>

<style scoped lang="scss">
.close-modal-btn .icon {
  background-color: $color-secondary;
  color: $color-gray-300;
  height: 28px;
  width: 28px;

  &::before {
    font-weight: $font-weight-bold;
  }
}
</style>
